import React, { useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Typography, Grid, Card, CardContent, Divider, useTheme} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import banking from "../../../images/banking.svg";
import insuranceIcon from "../../../images/insuranceIcon.svg";
import lifescience from "../../../images/lifescience.svg";
import retail from "../../../images/retail.svg";
import Monolithic from "../../../images/Monolithic.svg";
import Layered from "../../../images/Layered.svg";
import MicorService from "../../../images/MicroService.svg";
import EventDriven from "../../../images/EventDriven.svg";
import thermofisher from "../../../images/thermofisher.svg";
import SageSure from "../../../images/SageSure.svg";
import DollarTree from "../../../images/DollarTree.svg";
import NVIDIA from "../../../images/NVIDIA.svg";
import TestStrategyIcon from "../../../images/testStrategyIcon.svg";
import SecurityTestingIcon from "../../../images/securityTestingIcon.svg"

const iconStyle = {
  width: '50px',
  height: '80px',
  marginLeft: '-20px',
};

const sections = [
  {
    title: 'Domain Knowledge RAG Sources',
    items: [
      { label: 'Banking', icon: <img src={banking} alt="Banking" style={iconStyle} labelStyle="labelStyle" /> },
      { label: 'Insurance', icon: <img src={insuranceIcon} alt="Insurance" style={iconStyle} /> },
      { label: 'Healthcare', icon: <img src={lifescience} alt="Healthcare" style={iconStyle} /> },
      { label: 'eCommerce', icon: <img src={retail} alt="Retail" style={iconStyle} /> },
      { label: 'Cruise', icon: <img src={retail} alt="Retail" style={iconStyle} /> },
    ],
  },
  {
    title: 'Enterprise Architecture Archetypes',
    items: [
      { label: 'Monolithic', icon: <img src={Monolithic} alt="Monolithic" style={iconStyle} /> },
      { label: 'LLM-Centric', icon: <img src={Monolithic} alt="Monolithic" style={iconStyle} /> },
      { label: 'Cloud-Native', icon: <img src={Monolithic} alt="Monolithic" style={iconStyle} /> },
      { label: 'SaaS', icon: <img src={Monolithic} alt="Monolithic" style={iconStyle} /> },
      { label: 'Legacy', icon: <img src={Monolithic} alt="Monolithic" style={iconStyle} /> },
      { label: 'Layered \n Architecture', icon: <img src={Layered} alt="Layered" style={iconStyle} /> },
      { label: 'MicroServices', icon: <img src={MicorService} alt="Microservices" style={iconStyle} /> },
      { label: 'EventDrivenArchitecture', icon: <img src={EventDriven} alt="EDA" style={iconStyle} /> },


    ],
  },
  {
    title: 'Client-Specific Knowledge Bases',
    items: [
      { label: 'Thermo Fisher', icon: <img src={thermofisher} alt="Thermo Fisher" style={iconStyle} /> },
      { label: 'SageSure', icon: <img src={SageSure} alt="SageSure" style={iconStyle} /> },
      { label: 'Dollar Tree', icon: <img src={DollarTree} alt="Dollar Tree" style={iconStyle} /> },
      { label: 'NVIDIA', icon: <img src={NVIDIA} alt="NVIDIA" style={iconStyle} /> },
      { label: 'Visual Matrix', icon: <img src={NVIDIA} alt="Visual Matrix" style={iconStyle} /> },
      { label: 'QEStrategy', icon: <img src={TestStrategyIcon} alt="QEStrategy" style={iconStyle} /> },
      { label: 'AAA', icon: <img src={TestStrategyIcon} alt="AAA" style={iconStyle} /> },
      { label: 'SecurityTesting', icon: <img src={SecurityTestingIcon} alt="SecurityTesting" style={iconStyle} /> },
 
    ],
  },
];

const KnowledgeBaseSelect = () => {
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const theme = useTheme();

  const handleCardClick = (item) => {
    const collectionName = item.label.replace(/ /g, '_');
    navigate('/dashboard/admin-navigation/knowledgebase/upload', {
      state: { collection: collectionName },
    });
  };

  // Filtered sections based on search text
  const filteredSections = sections
    .map(section => ({
      ...section,
      items: section.items.filter(item =>
        item.label.toLowerCase().includes(searchText.toLowerCase())
      )
    }))
    .filter(section => section.items.length > 0);

  return (
    <Box sx={{
      p: { xs: 1, md: 2 },
      pt: { xs: 1, md: 2 },
      pr: { xs: 1, md: 4 },
      pb: { xs: 1, md: 4 },
      pl: { xs: 1, md: 4 },
      background: '#F7F7F5',
      minHeight: '100vh',
      overflowY: 'auto'
    }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 5,
          flexWrap: 'wrap',
        }}
      >
        <Typography
          variant="h5"
          fontWeight={500}
          sx={{ flexShrink: 0 }}
        >
          Knowledge Base Management
        </Typography>

        <Box
          sx={{
            width: { xs: '100%', sm: '300px', md: '350px' },
            mt: { xs: 2, sm: 0 },
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            size="medium"
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              sx: {
                backgroundColor: '#fff',
                borderRadius: 2,
              },
            }}
          />
        </Box>
      </Box>
      {filteredSections.length === 0 && (
        <Typography sx={{ color: theme.palette.grey[600], mt: 4 }}>
          No results found.
        </Typography>
      )}
      {filteredSections.map((section) => (
  <Box key={section.title} sx={{ mb: 4 }}>
    <Typography
      variant="subtitle1"
      fontWeight={550}
      sx={{ mb: 2, color: theme.palette.grey[900] }}
    >
      {section.title}
    </Typography>
 
    {/* Horizontally scrollable container */}
    <Box
      sx={{
        display: 'flex',
        overflowX: 'auto',
        gap: 3,
        pb: 1,
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
      height: 8,
    },
    '&:hover::-webkit-scrollbar-thumb': {
      backgroundColor: '#b0b0b0',
    },
    '&:hover::-webkit-scrollbar-track': {
      backgroundColor: '#f0f0f0',
    },
 
    // Optional for Firefox
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&:hover': {
      scrollbarColor: '#b0b0b0 #f0f0f0',
    },
  }}
    >
      {section.items.map((item) => (
        <Box
          key={item.label}
          sx={{
            flex: '0 0 auto',
            width: 250, // Fixed width for each card
          }}
        >
          <Card
            sx={{
              cursor: 'pointer',
              borderRadius: 2,
              boxShadow: 'none',
              border: '1px solid #D9D9D9',
              background: '#fff',
              minHeight: 117,
              height: 117,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'box-shadow 0.2s, border-color 0.2s',
              '&:hover': {
                boxShadow: 2,
                borderColor: '#1976d2',
              },
            }}
            onClick={() => handleCardClick(item)}
          >
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                p: 0,
                pl: 5,
                width: '100%',
                height: '100%',
                justifyContent: 'flex-start',
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                {item.icon}
              </Box>
              <Box sx={{ ml: 2 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight={400}
                  sx={{
                    textAlign: 'left',
                    color: '#1B1919',
                    lineHeight: 1.2,
                    whiteSpace: 'normal',
                  }}
                >
                  {item.label.split('\n').map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      {idx < item.label.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Box>
      ))}
    </Box>
  </Box>
))}
    </Box>
  );
};

export default KnowledgeBaseSelect; 